<template>
  <div class="yt-user-list">
    <GridTable
      ref="gridTable"
      id="UserList"
      :title="`${title}${appendTitle || ''}`"
      :key="componentKey"
      urlPath="administratorsCms"
      :columns="columns"
      :schema="schema"
      :defaultServerParams="{ schoolId: filteredBySchool }"
      @setModeSchema="onSetModeSchema"
      @changeDataModel="onChangeDataModel"
    />
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import VueFormGenerator from 'vue-form-generator'

import { fixAutofillInput } from '@/config'
import AccessMixin from '@/lib/mixins/access'
import BaseList from '@/components/BaseList'

const appModule = namespace('app')

@Component({
  mixins: [AccessMixin]
})
export default class UserList extends BaseList {
  @appModule.State('baseUrl') baseUrl
  @appModule.State('schools') stateSchools
  @appModule.State('filterBySchool') stateFilterBySchool

  title = 'Admin Users'

  columns = [
    {
      label: 'First Name',
      field: 'firstName',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by Name', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        // filterDropdownItems: ['Jon 1', 'Jon 2'], // dropdown (with selected values) instead of text input
        // isMultiselect: true,
        // filterFn: this.columnFilterFn, // custom filter function that
        trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'Last Name',
      field: 'lastName',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by Lastname', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'School',
      field: 'school.name',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by School', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        filterDropdownItems: [], // dropdown (with selected values) instead of text input
        isMultiselect: true,
        fieldNameFilter: 'schoolId'
        // filterFn: this.columnFilterFn, // custom filter function that
        // trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'Role',
      field: rowObj => {
        return rowObj.user && rowObj.user.role === 'superadmin'
          ? '<span class="badge badge-primary">Super Admin</span>'
          : '<span class="badge badge-success">Administrator</span>'
      }
    },
    {
      label: 'Active',
      field: 'user.isActive',
      type: 'switch'
    },
    {
      label: 'Actions',
      field: 'actions'
    } /* ,
        {
            label: '',
            field: 'dinamicView',
            type: 'dinamicView',
            dinamicView: {
                buttonLabel: 'View',
                modalTitle: 'Lesson List',
                modalWidth: 1024,
                component: () => import('@/components/lessons/LessonList')
            }
        } */
    // {
    //   label: 'Price',
    //   field: 'price',
    //   type: 'number',
    //   filterOptions: {
    //     enabled: true, // enable filter for this column
    //     placeholder: 'Filter by Age', // placeholder for filter input
    //     filterValue: '', // initial populated value for this filter
    //     filterDropdownItems: [16, 20, 24, 40, 55], // dropdown (with selected values) instead of text input
    //     filterFn: this.columnFilterFn, // custom filter function that
    //     trigger: 'enter' // only trigger on enter not on keyup
    //   }
    // }
  ]

  schema = {
    fields: [
      {
        // label: 'ID (disabled text field)',
        model: '_id',
        type: 'input',
        inputType: 'hidden',
        readonly: true,
        visible: false
      },
      {
        label: 'Username',
        model: 'username',
        type: 'input',
        inputType: 'text',
        placeholder: 'Your username',
        featured: true,
        required: true,
        autocomplete: 'off',
        // readonly: true,
        validator: VueFormGenerator.validators.string.locale({
          fieldIsRequired: 'The username is required!'
        })
      },
      {
        label: 'First Name',
        model: 'firstName',
        type: 'input',
        inputType: 'text',
        placeholder: 'Your name',
        required: true,
        autocomplete: false,
        validator: VueFormGenerator.validators.string.locale({
          // fieldIsRequired: 'The name is required!'
        })
      },
      {
        label: 'Last Name',
        model: 'lastName',
        type: 'input',
        inputType: 'text',
        // min: 6,
        required: true,
        // hint: 'Minimum 6 characters',
        autocomplete: false,
        validator: VueFormGenerator.validators.string
      },
      {
        label: 'Email',
        model: 'email',
        type: 'input',
        inputType: 'email',
        // min: 6,
        required: true,
        // hint: 'Minimum 6 characters',
        autocomplete: 'off',
        // readonly: true,
        attributes: {
          onfocus: fixAutofillInput
        },
        validator: VueFormGenerator.validators.email
      },
      {
        type: 'select',
        label: 'Role',
        model: 'user.role',
        values: [
          { id: 'superadmin', name: 'Super Administrator' },
          { id: 'administrator', name: 'Administrator' }
        ]
      },
      {
        label: 'School',
        model: 'schoolId',
        type: 'select',
        featured: true,
        required: true,
        // values: function () {
        //     return [
        //         { id: 'superadmin', name: 'Super Admin' }
        //     ]
        // },
        validator: VueFormGenerator.validators.required.locale({
          fieldIsRequired: 'School is required!'
        })
        // disabled: true
      },
      {
        label: 'Password',
        model: 'password',
        type: 'input',
        inputType: 'password',
        required: true,
        readonly: true,
        min: 8,
        attributes: {
          onfocus: fixAutofillInput
        },
        validator: ['required', 'string']
      },
      /* {
                label: 'Password Confirmation',
                model: 'confirmPassword',
                type: 'input',
                inputType: 'password',
                // minlength: 4,
                validator: ['confirmEqualValidator'], // ['confirmEqualValidator'],
                confirmField: {
                    field: 'password',
                    message: 'Password confirmation is invalid.'
                }
            }, */
      {
        label: 'Active',
        model: 'user.isActive',
        type: 'switch',
        multi: true,
        readonly: false,
        featured: false,
        disabled: false,
        default: true,
        textOn: 'Active',
        textOff: 'Inactive'
      }
    ]
  }

  created() {
    // this.baseUrl = `${baseUrl}`
    // this.onGetSchools()
  }

  onChangeDataModel(dataModel) {
    console.log('dataModel', dataModel)
    if (dataModel.user && dataModel.user.role === 'superadmin') {
      const fieldSchool = this.getConfigByModel('schoolId')
      fieldSchool.label = null
      fieldSchool.required = false
      fieldSchool.visible = false
    } else {
      const fieldSchool = this.getConfigByModel('schoolId')
      fieldSchool.label = 'School'
      fieldSchool.required = true
      fieldSchool.visible = true
    }
  }

//  onActionImportFile() {
//     if (!this.filteredBySchool) {
//       this.$swal({
//         type: 'error',
//         title: 'Oops...',
//         text: 'Please first select a school from the top dropdown.'
//       })

//       return false
//     }

//     return true
//   }

  onSetModeSchema(mode) {
    const refGridTable = this.$refs.gridTable

    if (mode === 'update') {
      const school = refGridTable.getFieldDataSelectedRow('school')
      if (typeof school === 'object' && school.hasOwnProperty('_id')) {
        refGridTable.setFieldDataSelectedRow('schoolId', school._id)
      }

      const user = refGridTable.getFieldDataSelectedRow('user')
      if (typeof user === 'object' && user.hasOwnProperty('username')) {
        refGridTable.setFieldDataSelectedRow('username', user.username)
      }

      const defaultPassword = '******'
      refGridTable.setFieldDataSelectedRow('password', '')
      const fieldPassword = this.schema.fields.find(
        item => item.model === 'password'
      )
      fieldPassword.required = false
      fieldPassword.readonly = false
      fieldPassword.placeholder = defaultPassword
      /* fieldPassword.attributes = {
                onfocus: `
                    if (this.value === '${defaultPassword}') {
                        this.value = ''
                    }
                `,
                onblur: `
                    if (this.value === '') {
                        this.value = '${defaultPassword}'
                    }
                `
            } */

      const fieldUsername = this.schema.fields.find(
        item => item.model === 'username'
      )
      fieldUsername.attributes = {}
    } else if (mode === 'add') {
      this.schema.fields.find(item => item.model === 'password').required = true

      const fieldUsername = this.schema.fields.find(
        item => item.model === 'username'
      )
      fieldUsername.attributes = {
        onfocus: fixAutofillInput
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.yt-user-list {
  /deep/ .vue-form-generator {
    &.edit {
      input#username {
        &:disabled,
        &[readonly] {
          background-color: #e9ecef;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/UserList.vue